import { UIUserStatus } from "../types/user";

export function getStatusStyles(status: UIUserStatus) {
  const statusesStyles: Record<
    UIUserStatus,
    {
      color:
        | "base"
        | "primary"
        | "secondary"
        | "warning"
        | "success"
        | "info"
        | "error";
    }
  > = {
    [UIUserStatus.INACTIVE]: {
      color: "base",
    },
    [UIUserStatus.ACTIVE]: {
      color: "success",
    },
    [UIUserStatus.PENDING]: {
      color: "primary",
    },
  };

  return statusesStyles[status];
}
